/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowRotaryStraight = createReactComponent("outline", "arrow-rotary-straight", "IconArrowRotaryStraight", [["path", { "d": "M13 13m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-0" }], ["path", { "d": "M13 16v5", "key": "svg-1" }], ["path", { "d": "M13 3v7", "key": "svg-2" }], ["path", { "d": "M9 7l4 -4l4 4", "key": "svg-3" }]]);

export { IconArrowRotaryStraight as default };
//# sourceMappingURL=IconArrowRotaryStraight.mjs.map
